<template>
  <BaseAction>
    <SecondaryButton @click.native="openCloseBookingDialog" color="primary">
      <div class="d-flex align-center">
        <v-icon size="1.5rem">
          mdi-briefcase-outline
        </v-icon>
        <inline-svg :src="require('@/assets/svg/check_white.svg')" />
      </div>
      Close Role
    </SecondaryButton>
    <CloseBookingDialog
      :isOpen="isCloseBookingOpen"
      @close="closeCloseBookingDialog"
    />
  </BaseAction>
</template>

<script>
import CloseBookingDialog from "@/views/bookings/components/ConfirmDialogs/CloseBookingDialog";
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import BaseAction from "@/components/common/BaseAction";
import InlineSvg from "vue-inline-svg";

export default {
  name: "CloseBookingAction",
  components: { BaseAction, SecondaryButton, CloseBookingDialog, InlineSvg },
  data() {
    return {
      isCloseBookingOpen: false
    };
  },
  methods: {
    openCloseBookingDialog() {
      this.isCloseBookingOpen = true;
    },
    closeCloseBookingDialog() {
      this.isCloseBookingOpen = false;
    }
  }
};
</script>
